/*
✅ Removed showFinalQuotes state and logic.
✅ After PracticeSessionQuestions, user is directly redirected to PracticeSessionPostCompletion.
✅ No extra FinalQuotes step anymore.
✅ Console logs added for better debugging and tracking.

*/


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PracticeSessionQuestions from './PracticeSessionQuestions';
import Facts from './Facts';

const PracticeSessionPlay = () => {
  const { lessonId, topicId } = useParams();
  const navigate = useNavigate();

  // State management (Equivalent to iOS ViewModel)
  const [showFacts, setShowFacts] = useState(true);
  const [showPracticeQuestions, setShowPracticeQuestions] = useState(false);
  const [practiceSessionCompleted, setPracticeSessionCompleted] = useState(false);

  // Start onboarding process
  useEffect(() => {
    setShowFacts(true);
    setShowPracticeQuestions(false);
  }, []);

  // Handle moving to practice questions
  const startPracticeQuestions = () => {
    //console.log("✅ Transitioning to PracticeSessionQuestions...");
    setShowFacts(false);
    setShowPracticeQuestions(true);
  };

  // Handle session completion (no FinalQuotes step)
  const completePracticeSession = () => {
    //console.log("✅ Practice session completed. Redirecting...");
    setPracticeSessionCompleted(true);
    navigate('/practice-session-post-completion'); // Redirect to post-practice view
  };

  return (
    <div style={{ padding: '20px', backgroundColor: 'black', color: 'white', minHeight: '100vh' }}>
      {showFacts && <Facts onContinue={startPracticeQuestions} />}
      {showPracticeQuestions && (
        <PracticeSessionQuestions lessonId={lessonId} topicId={topicId} onComplete={completePracticeSession} />
      )}
    </div>
  );
};

export default PracticeSessionPlay;







// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import PracticeSessionQuestions from './PracticeSessionQuestions';
// import Facts from './Facts';
// import FinalQuotes from './FinalQuotes';

// const PracticeSessionPlay = () => {
//   const { lessonId, topicId } = useParams();
//   const navigate = useNavigate();

//   // State management (Equivalent to iOS ViewModel)
//   const [showFacts, setShowFacts] = useState(true);
//   const [showPracticeQuestions, setShowPracticeQuestions] = useState(false); // FIXED
//   const [showFinalQuotes, setShowFinalQuotes] = useState(false);
//   const [practiceSessionCompleted, setPracticeSessionCompleted] = useState(false);

//   // Start onboarding process
//   useEffect(() => {
//     setShowFacts(true);
//     setShowPracticeQuestions(false);
//     setShowFinalQuotes(false);
//   }, []);

//   // Handle moving to practice questions
//   const startPracticeQuestions = () => {
//     //console.log("Transitioning to PracticeSessionQuestions...");
//     setShowFacts(false);
//     setShowPracticeQuestions(true);
//   };

//   // Handle finishing questions and moving to final quotes
//   const finishPracticeQuestions = () => {
//     setShowPracticeQuestions(false);
//     setShowFinalQuotes(true);
//   };

//   // Handle session completion
//   const completePracticeSession = () => {
//     setPracticeSessionCompleted(true);
//     navigate('/practice-session-post-completion'); // Redirect to post-practice view
//   };

//   return (
//     <div style={{ padding: '20px', backgroundColor: 'black', color: 'white', minHeight: '100vh' }}>
//       {showFacts && <Facts onContinue={startPracticeQuestions} />} {/* FIXED */}
//       {showPracticeQuestions && <PracticeSessionQuestions lessonId={lessonId} topicId={topicId} onComplete={finishPracticeQuestions} />}
//       {showFinalQuotes && <FinalQuotes onContinue={completePracticeSession} />}
//     </div>
//   );
// };

// export default PracticeSessionPlay;

